// Kustom specific queries (Third-party)
class KustomParams {
  order_id?: string;
  merchant_id?: string;
  payment_method?: string;
  return_url?: string;
}

export class QueryParams extends KustomParams {
  id?: string;
  method?: string;
  methodType?: string;
  bidRequestId?: string;
  shouldOpenBankId?: string;
  error?: string;
  info?: string;
  termId?: string;
  swishId?: string;
  poppedSwish?: string;
  vippsId?: string;
  poppedVipps?: string;
  stateId?: string;
  debug?: string;
  fatal?: string;
  redirectOrdered?: string;
  depositStatus?: DepositStatus;
  precheckId?: string;
  instantDebitPaymentRequestId?: string;
  authorizationId?: string;
  result?: string;
  verifiedAccountId?: string;
  sessionId?: string;
  primaryColor?: string;
  secondaryColor?: string;
  backgroundColor?: string;
  windowMode?: string;
  autoStart?: string;
  child?: string;
  messageId?: string;
  inIframe?: string;

  // Resume a state when the session is lost
  resumeToken?: string;

  // Loan calculator only
  amount?: string;
  color?: string;
  isFromLoanCalculator?: string;

  // Kustom specific queries
  orderId?: string;
  merchantId?: string;
  paymentMethod?: string;
  returnUrl?: string;

  // Tink specific redirection
  account_verification_report_id?: string;
  state?: string;
  //NB: "error" is supposed to be here but already defined above
  message?: string;
  error_display_message?: string;
  error_reason?: string;
  error_type?: string;
  provider_name?: string;
  tracking_id?: string;
  payment_request_id?: string; // payment flow

  // Scrive specific queries
  transaction_id?: string;
  success?: string;

  // Finshark context (internal)
  requestContext?: string;

  // Used to retrieve the state from a redirect flow
  checkoutToken?: string;
  // Get the ais provider during a callback
  originProvider?: string;
}

export enum DepositStatus {
  PENDING = 'PENDING',
  FAIL = 'FAIL',
}
